module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 445
// module chunks = 0